import { render } from "./IdlingAgents.vue?vue&type=template&id=3427dbfc"
import script from "./IdlingAgents.vue?vue&type=script&lang=js"
export * from "./IdlingAgents.vue?vue&type=script&lang=js"

import "./IdlingAgents.vue?vue&type=style&index=0&id=3427dbfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__